const joinArrayString = (data, property) => {
  if (data && Array.isArray(data) && data.length) {
    return data.map((data) => data[property]).join(', ');
  } else {
    return '';
  }
};

export default joinArrayString;
